import gql from "graphql-tag";
import { graphql, QueryResult } from "react-apollo";

export interface IInputProps {
  giftCardCode: string;
  recaptchaToken: string;
}

interface IBalance {
  amount: string,
  currencyCode: string
}

export interface IGiftCard {
  id?: string,
  balance: IBalance,
  initialValue: IBalance,
  expiresOn: string | null,
  maskedCode: string,
};

export interface IGiftCardByCode {
  giftCardByCode: IGiftCard;
}

export interface IResponseProps {
  giftCardByCodeQuery: IGiftCardByCode & QueryResult;
}

export const GIFT_CARD_BY_CODE_QUERY = gql`
  query GiftCardByCode($code: String!, $gRecaptchaToken: String!) {
    giftCardByCode(code: $code, gRecaptchaToken: $gRecaptchaToken) {
      id
      balance {
        amount
        currencyCode
      }
      initialValue {
        amount
        currencyCode
      }
      expiresOn
      maskedCode
    }
  }
`;

export const withGiftCardByCode = graphql<IInputProps>(GIFT_CARD_BY_CODE_QUERY, {
  name: "giftCardByCodeQuery",
  options({ giftCardCode, recaptchaToken }) {
    return {
      variables: {
        code: giftCardCode,
        recaptchaToken
      }
    };
  }
});



// WEBPACK FOOTER //
// ./src/graphql/queries/giftCard/giftCardByCode.ts